import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=6b40ac04&scoped=true&"
import script from "./Teams.vue?vue&type=script&lang=js&"
export * from "./Teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40ac04",
  null
  
)

export default component.exports